import { render, staticRenderFns } from "./AddPiiModal.vue?vue&type=template&id=26b5078c&"
import script from "./AddPiiModal.vue?vue&type=script&lang=js&"
export * from "./AddPiiModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports